// @flow
import React, {PureComponent} from 'react'
import I18n from 'I18n'
import {Link} from 'react-router-dom'
import ReactTable from 'react-table'
import styles from './ClientList.module.scss'
import 'react-table/react-table.css'
import AddClientModal from './AddClientModal'
import {adminURL} from 'modules/Common/constants'

import {formatTimestampToDate} from 'modules/Common/utils'

import type {StateProps, DispatchProps, OwnProps} from '../../containers/ClientListContainer'

export type Props = DispatchProps & StateProps & OwnProps;

export type State = {
  isShowAddModal: boolean
};

const I18nLocal = I18n.admin

export class AdminAMList extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isShowAddModal: false
    }
  }

  handleOpenAddModal = () => {
    this.setState({
      isShowAddModal: true
    })
  }
  handleCloseAddModal = () => {
    this.setState({
      isShowAddModal: false
    })
  }
  fetchData = (state: any, instance: any) => {
    this.props.getClients(state.page + 1).then(() => {
      const companyIds = []
      const userIds = []
      this.props.clients.ids.map(key => {
        const item = this.props.clients.records[key]
        if (!companyIds.includes(item.companyId) && item.companyId !== '') {
          companyIds.push(item.companyId)
        }
        if (item.id && !userIds.includes(item.id) && item.id !== '') {
          userIds.push(item.id)
        }
        return null
      })
      this.props.getCompanies(1, companyIds)
      this.props.getAccountManagers(1, userIds)
    })
  }
  calculateData = () => {
    return this.props.clients.ids.map(key => {
      const item = this.props.clients.records[key]
      const company = this.props.companies.records[item.companyId]
      const accountManager = item.id ? this.props.accountManagers.records[item.id] : {}
      return {
        id: item.id,
        name: item.name,
        email: item.persona.email,
        phoneNumber: item.persona.mobilePhoneNumber,
        accountManager: (accountManager && accountManager.name) || '',
        accountManagerId: (accountManager && accountManager.id) || '',
        company: company ? company.name : '',
        companyId: item.companyId,
        status: item.status,
        lastLoggedIn: formatTimestampToDate(item.lastUpdateTimestamp, 'HH:mm DD/MM/YYYY')
      }
    })
  }

  render() {
    const data = this.calculateData()

    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <span className={this.props.isSubScreen ? styles.small : ''}>{I18nLocal.clients}</span>
          <div onClick={this.handleOpenAddModal} className={styles.button}>
            {I18nLocal.addClient}
          </div>
        </div>
        <div className={styles.table}>
          <ReactTable
            showPageSizeOptions={false}
            sortable={false}
            data={data}
            columns={[
              {
                id: 'index',
                Header: '#',
                Cell: props => {
                  return props.index + 1
                }
              },
              {
                id: 'name',
                Header: I18nLocal.name,
                accessor: 'name'
              },
              {
                Header: I18nLocal.email,
                Cell: props => {
                  return <span>{props.original.email}</span>
                }
              },
              {
                Header: I18nLocal.phoneNumber,
                accessor: 'phoneNumber'
              },
              {
                Header: 'Account Manager',
                Cell: props => {
                  return (
                    <Link className={styles['link']} to={adminURL.accountManagers.edit.replace(':id', props.original.accountManagerId)}>
                      {props.original.accountManager}
                    </Link>
                  )
                }
              },
              {
                Header: I18nLocal.company,
                Cell: props => {
                  return (
                    <Link className={styles['link']} to={adminURL.companies.detail.replace(':id', props.original.companyId)}>
                      {props.original.company}
                    </Link>
                  )
                }
              },
              {
                Header: 'Status',
                accessor: 'status'
              }
            ]}
            manual
            pages={this.props.clients.numberOfPages}
            loading={this.props.isLoadingAccountManagers}
            onFetchData={this.fetchData}
          />
        </div>
        <AddClientModal
          handleClickButton={this.props.inviteNewClient}
          handleClose={this.handleCloseAddModal}
          isShow={this.state.isShowAddModal}
          error={this.props.error}
          companyId={this.props.companyId || undefined}
          companyName={this.props.companyName || undefined}
          isLoadingCompaniesSuggestion={this.props.isLoadingCompaniesSuggestion}
          isLoadingAccountManagersSuggestion={this.props.isLoadingAccountManagersSuggestion}
          companiesSuggestion={this.props.companiesSuggestion}
          getCompaniesSuggestion={this.props.getCompaniesSuggestion}
          accountManagersSuggestion={this.props.accountManagersSuggestion}
          getAccountManagersSuggestion={this.props.getAccountManagersSuggestion}
        />
      </div>
    )
  }
}

export default AdminAMList
